"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listRoutes = {
    show: "/:slug(.*)*/a/:type/:id",
};



//////////////////
// WEBPACK FOOTER
// ./packages/dotcom-routing/dist/lists/routes.js
// module id = U04J
// module chunks = 2